import { IsString } from 'class-validator';

export interface SaExerciseUserFavorite {
  exerciseId: string;
  userId: string;
}

export class SaExerciseUserFavoriteDTO {
  exerciseId: string;
  @IsString()
  userId: string;
}
